import { join } from 'node:path';
import type { InlineConfig } from 'vite';
import { normalizePath } from 'vite';
import { getAppBuildFolder } from '@wix/cli-app-definitions';
import tsconfigPaths from '@wix/vite-tsconfig-paths';
import type { ViteBuildConfigOptions } from '../../vite-config-options.js';
import type { ProjectModel } from '../../../model.js';
import { API_BASEURL_PLACEHOLDER } from '../../../hosting/upload-application.js';
import { webMethodsPlugin } from '../../plugins/web-methods-plugin.js';
import { fbjsHotfixPlugin } from '../../plugins/fbjs-hotfix-plugin.js';
import { monitoring } from '../../plugins/monitoring.js';
import { forceHashRefresh } from '../../plugins/force-hash-refresh.js';

interface Options extends ViteBuildConfigOptions {
  model: ProjectModel;
  outputDir: string;
}

export function getBaseViteConfig({ model, outputDir, customLogger }: Options) {
  return {
    configFile: false,
    root: model.projectFolder,
    customLogger,
    clearScreen: false,
    logLevel: 'info',
    publicDir: false,
    build: {
      sourcemap: true,
      outDir: getAppBuildFolder(model.projectFolder),
      emptyOutDir: false,
      rollupOptions: {
        output: {
          assetFileNames: normalizePath(
            join(outputDir, 'assets/[name].ch.[hash][extname]')
          ),
          chunkFileNames: normalizePath(
            join(outputDir, 'assets/[name].ch.[hash].js')
          ),
          entryFileNames: normalizePath(
            join(outputDir, 'assets/[name].ch.[hash].js')
          ),
        },
      },
    },
    define: {
      'import.meta.env.BASE_API_URL': JSON.stringify(
        `${API_BASEURL_PLACEHOLDER}/functions`
      ),
    },
    plugins: [
      webMethodsPlugin({
        projectFolder: model.projectFolder,
      }),
      fbjsHotfixPlugin(),
      monitoring({ initialModel: model }),
      tsconfigPaths({
        ignoreConfigErrors: true,
        root: model.projectFolder,
      }),
      forceHashRefresh(),
    ],
  } satisfies InlineConfig;
}
